// Define CommandResult type if not imported from elsewhere
export interface CommandResult {
  validationMessages: { level: string }[];
}

export function commandResultHasErrors(result: CommandResult): boolean {
  return result.validationMessages.some((validationResult: { level: string }) => validationResult.level === 'Error');
}
